import { useAdminOrganizationsQuery } from "../../api/queries/adminQueries";
import { AdminScope } from "../auth/AdminScope";
import { DraftValidationDraftsTab } from "./DraftValidationDraftsTab";

const DraftValidationPage = () => {
  const { data: organizations = [] } = useAdminOrganizationsQuery();

  return (
    <AdminScope>
      <div className="min-h-full min-w-full bg-slate-50">
        <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 py-6 md:px-6 lg:px-8">
          <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <h1 className="text-2xl font-semibold text-slate-900">
              Draft Debug & Inspection
            </h1>
            <p className="mt-1 text-sm text-slate-600">
              Unified view for generation traces, snapshots, attempts, and
              composer edits.
            </p>
            <div className="mt-4 rounded-xl border border-emerald-200 bg-emerald-50 p-4">
              <p className="text-sm font-medium text-emerald-900">
                Table audit (retain)
              </p>
              <ul className="mt-2 list-inside list-disc text-sm text-emerald-800">
                <li>
                  <code>draft_generation_trace</code>: actively read/written in
                  draft generation and admin inspection.
                </li>
                <li>
                  <code>draft_generation_input_snapshot</code>: used for
                  snapshot context in draft validation detail.
                </li>
                <li>
                  <code>draft_generation_attempt</code>: used for
                  attempt/guardrail metadata in generation summaries.
                </li>
                <li>
                  <code>draft_edit_diff</code>: used for composer edit summaries
                  and review deltas.
                </li>
              </ul>
            </div>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <DraftValidationDraftsTab organizations={organizations} />
          </div>
        </div>
      </div>
    </AdminScope>
  );
};

export default DraftValidationPage;
